<template>
    <div class="tipe_content" v-if="bOptional" @click.stop="bShowOpiton">
        <div class="tips_optional" @click.stop>
            <div class="input-area-close" @click.stop="bShowOpiton"></div>
            <div class="tips_title">
                <div>
                    {{
                        "Step" +
                        objGoods.info.step +
                        ":" +
                        objGoods.info.type_group_name
                    }}
                </div>
                <div class="title_btn" @click="complete">完成</div>
            </div>
            <div class="tips_shopp">
                <div class="tabel_title">
                    <div class="tabel_title_item">名称</div>
                    <div class="tabel_title_item">规格型号</div>
                    <div class="tabel_title_item">数量</div>
                    <div class="tabel_title_item">单价</div>
                    <div class="tabel_title_item">操作</div>
                </div>
                <div class="tabel_content">
                    <div
                        class="tabel_content_list"
                        v-for="(item, index) in objGoods.goods"
                        :key="index"
                    >
                        <div class="tabel_content_item">{{ item.name }}</div>
                        <div class="tabel_content_item">{{ item.code }}</div>
                        <div class="tabel_content_item">
                            <input
                                type="number"
                                @click="getTips(item, index, 0)"
                                readonly
                                :value="item.num"
                            />
                        </div>
                        <div class="tabel_content_item">
                            <!-- @click="getTipsInput(index, item, 1)" -->
                            <input
                                type="number"
                                @click="getTips(item, index, 1)"
                                readonly
                                :value="item.amount"
                            />
                        </div>
                        <div class="tabel_content_item">
                            <div class="btn" @click="getRepleac(item, index)">
                                修改
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom_add" @click="getReplaceShopp('add')">
                添加项目
            </div>
        </div>
        <!-- 选择数量弹窗 -->
        <div class="mask" v-if="areaPopupShow" @click.stop>
            <div class="input-area-popup">
                <div
                    class="input-area-close"
                    @click.stop="areaPopupShow = false"
                ></div>
                <div class="input-area-title">{{ objItem.name }}:</div>
                <div class="input-area-content">
                    <div class="input-wrap">
                        <input
                            type="number"
                            pattern="[0-9]*"
                            name=""
                            v-model="areaPopupInputVal"
                        />
                        <span>{{ objItem.type == 0 ? "个" : "元" }}</span>
                    </div>
                </div>
                <div class="input-area-btn">
                    <button @click.stop="areaOpiton()">确定</button>
                </div>
            </div>
        </div>
        <!-- 互斥警告弹窗 -->
        <div class="mask" v-if="false">
            <div class="input-area-popup">
                <div
                    class="input-area-close"
                    @click.stop="areaPopupShow = false"
                ></div>
                <div class="muck-title">温馨提示</div>
                <div class="tips-muck">{{ sTipsTitle }}</div>
                <div class="shopp_btn">
                    <div @click.stop="getAddShopp">确认</div>
                    <div @click.stop="bShoppMatch = false">取消</div>
                </div>
            </div>
        </div>
        <!-- 选择替换删除弹窗 -->
        <div class="repleac" v-if="bRepleac" @click.stop="bRepleac = false">
            <div class="repleac_tips" @click.stop>
                <div class="btn_item" @click.stop="getReplaceShopp('edit')">
                    替换
                </div>
                <div class="btn_item" @click.stop="repleacDel">删除</div>
            </div>
        </div>
        <!-- 选配商品弹窗 -->
        <div
            class="match_shopp_tips"
            v-if="bShoppMatch"
            @click.stop="bShoppMatch = false"
        >
            <div class="shopp_content" @click.stop>
                <div class="shopp_title" v-if="this.sReplaceType!='add'">
                    选择修改商品：{{ arrItemName.name }}
                </div>
                <div class="shopp_seach">
                    <div class="shopp_input">
                        <input
                            type="text"
                            @input="getInputSeach"
                            v-model="sInputWord"
                            placeholder="搜索项目"
                        />
                    </div>
                    <div class="shopp_choice">
                        <span>全部/选配</span
                        ><mt-switch v-model="bSave" @change="turn"></mt-switch>
                    </div>
                </div>
                <div class="shopp_list">
                    <div class="tabel_shopp_th">
                        <div class="tabel_shopp_th_tab">名称</div>
                        <div class="tabel_shopp_th_tab">规格型号</div>
                        <div class="tabel_shopp_th_tab">单价</div>
                    </div>
                    <div class="tabel_shopp_tb" v-if="arrMatchShopp.length">
                        <div
                            class="tabel_shopp_tb_list"
                            v-for="(item, index) in arrMatchShopp"
                            @click="getOptShopp(index)"
                            :style="{
                                border: item.open ? '1px solid red' : '',
                            }"
                            :key="index"
                        >
                            <div class="tabel_shopp_tb_item">
                                {{ item.name }}
                            </div>
                            <div class="tabel_shopp_tb_item">
                                {{ item.code }}
                            </div>
                            <div class="tabel_shopp_tb_item">
                                {{ item.amount }}
                            </div>
                        </div>
                    </div>
                    <div class="tabel_shopp_tb_text" v-else>暂无数据~</div>
                </div>
                <div class="shopp_btn">
                    <div @click.stop="getAddShopp">确认</div>
                    <div @click.stop="bShoppMatch = false">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js';
import { Toast } from "mint-ui";
import oDetail from "@/js/detail.js";
export default {
    components: {
        Toast,
    },
    props: {
        bOptional: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            bShoppMatch: false,
            bSave: false,
            arrMatchShopp: [],
            bRepleac: false,
            areaPopupShow: false,
            areaPopupInputVal: 0,
            objItem: {}, //选配的产品
            nRepleacIndex: 0, //当前需要修改的索引
            sInputWord: "",
            shoppIndex: 0,
            sReplaceType: "",
            nShoppIndexEq: 0,
            objGoods: {},
            arrItemName: {},
        };
    },
    watch: {
        bOptional() {
            if (this.bOptional) {
                // this.objGoods = JSON.parse(localStorage.getItem("arrOffter"));
                this.objGoods = JSON.parse(oStorage.getStorage("arrOffter"));
            }
        },
    },
    methods: {
        //完成按钮
        complete() {
            this.$emit("complete", this.objGoods);
            this.$emit("update:bOptional", false);
        },
        //搜索商品
        getInputSeach(e) {
            let _that = this;
            _that.debounce(() => {
                this.getParts();
            }, 500);
        },
        //节流函数防抖
        debounce(fn, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function () {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },
        //选择商品
        getOptShopp(shoppIndex) {
            this.shoppIndex = shoppIndex;
            this.arrMatchShopp.forEach((it, index) => {
                if (shoppIndex == index) {
                    it.open = !it.open;
                } else {
                    it.open = false;
                }
            });
        },
        getTips(item, index, type) {
            let itemData = {
                id: item.optional_id,
                name: item.name,
                amount: item.amount,
                code: item.code,
                type: type,
                goodsIndex: index,
            };
            switch (type) {
                case 0:
                    this.areaPopupInputVal = item.num;
                    break;
                case 1:
                    this.areaPopupInputVal = item.amount;
                    break;
            }
            this.objItem = itemData;
            this.areaPopupShow = true;
        },
        //删除
        repleacDel() {
            this.objGoods.goods.splice(this.nRepleacIndex, 1);
            this.bRepleac = false;
        },
        //唤起选择弹窗
        getRepleac(item, index) {
            this.arrItemName = item;
            this.bRepleac = true;
            this.nRepleacIndex = index;
        },
        getReplaceShopp(type) {
            this.sReplaceType = type;
            this.bShoppMatch = true;
            this.bRepleac = false;
            this.getParts();
        },
        getParts() {
            let partsData = {
                type:
                    this.objGoods.info.id == 7 ? "host" : this.objGoods.info.id,
                is_optional: this.bSave ? "1" : "0",
                search: this.sInputWord || "",
            };
            this.$store.commit("loadSwitch", true);
            oDetail.getParts(partsData).then((res) => {
                res.result.forEach((it) => {
                    it.open = false;
                    it.num = 1;
                });
                this.arrMatchShopp = res.result;
                this.$store.commit("loadSwitch", false);
            });
        },
        turn() {
            this.getParts();
        },
        //确认添加商品
        getAddShopp() {
            let _that = this;
            this.arrMatchShopp[this.shoppIndex].eait = true;
            if (this.sReplaceType == "edit") {
                let nShoppId = this.arrMatchShopp[this.shoppIndex].id;
                let arrShoppEque = this.objGoods.goods.filter((it, index) => {
                    if (it.id == nShoppId) {
                        this.nShoppIndexEq = index;
                    }
                    return it.id == nShoppId;
                });
                if (arrShoppEque.length) {
                    this.objGoods.goods[this.nShoppIndexEq].num += 1;
                    this.objGoods.goods.splice(this.nRepleacIndex,1);
                } else {
                    this.objGoods.goods[this.nRepleacIndex] =
                        this.arrMatchShopp[this.shoppIndex];
                }
            } else if (this.sReplaceType == "add") {
                let nShoppId = this.arrMatchShopp[this.shoppIndex].id;
                let nOptionalId = this.arrMatchShopp[this.shoppIndex].optional_id;
                let arrMuckShopp = this.objGoods.goods.filter((it, index) => {
                    return it.id == nOptionalId;
                });
                let arrShoppEque = this.objGoods.goods.filter((it, index) => {
                    if (it.id == nShoppId) {
                        this.nShoppIndexEq = index;
                    }
                    return it.id == nShoppId;
                });
                if (arrShoppEque.length) {
                    //  console.log(this.arrMatchShopp[this.shoppIndex].num)
                    this.objGoods.goods[this.nShoppIndexEq].optional_id = this.arrMatchShopp[this.shoppIndex].optional_id;
                    //  console.log(this.objGoods.goods,this.arrMatchShopp[this.shoppIndex])
                    this.objGoods.goods[this.nShoppIndexEq].num +=1;
                } else {
                    if(arrMuckShopp.length){
                        this.objGoods.goods.splice(this.nShoppIndexEq,1);
                    }
                    this.objGoods.goods.unshift(
                        this.arrMatchShopp[this.shoppIndex]
                    );
                }
            }
            this.bShoppMatch = false;
        },
        areaOpiton() {
            switch (this.objItem.type) {
                case 0:
                    this.objGoods.goods[this.objItem.goodsIndex].num =
                        this.areaPopupInputVal;
                    break;
                case 1:
                    this.objGoods.goods[this.objItem.goodsIndex].amount =
                        this.areaPopupInputVal;
                    break;
            }
            // if (this.areaPopupInputVal == 0) {
            //     Toast({
            //         message: "商品数量不能为0",
            //         duration: 1200,
            //     });
            //     return false;
            // }
            // this.objItem.num = this.areaPopupInputVal;
            this.areaPopupShow = false;
        },
        bShowOpiton() {
            this.$emit("update:bOptional", false);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
